/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./reset-game-config.vue?vue&type=template&id=75ed1722&scoped=true&"
import script from "./reset-game-config.vue?vue&type=script&lang=js&"
export * from "./reset-game-config.vue?vue&type=script&lang=js&"
import style0 from "./reset-game-config.vue?vue&type=style&index=0&id=75ed1722&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ed1722",
  null
  
)

export default component.exports